import { gql } from '@apollo/client';
import unavailablePeriodFragment from '../unavailablePeriodFragment';

const ADD_ORG_UNIT_UNAVAILABLE_PERIOD = gql`
  mutation AddOrgUnitUnavailablePeriod($period: UnavailablePeriodInput!) {
    addOrgUnitUnavailablePeriod(period: $period) {
      UnavailablePeriod {
        ...UnavailablePeriodFields
      }
    }
  }
  ${unavailablePeriodFragment}
`;

export default ADD_ORG_UNIT_UNAVAILABLE_PERIOD;
